import styled from "styled-components";

export const CustomDatePickerContainer = styled.div`
    margin-bottom: 10px;
    /* width: 100%; */

    label{
        font-size: 13px;
        text-transform: capitalize;
        
        display: block;
        margin-bottom: 10px;
    }



    .ant-picker.customdatepicker{
        width: 100% !important;
        /* padding: 10px; */
        border-radius: 5px !important; 
        border: 1px solid #C6C6C8;
        //padding: 8px 8px;
    }
    .ant-picker {
    padding: 8px 8px !important;
}
`